let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("iaWKj")), load("9IGND")]).then(() => parcelRequire('8FiQk'));